import React from 'react';
import PropTypes from 'prop-types';

import HelpMenuPanel from './Panel';

const HelpMenu = ({ ...props }) => (<HelpMenuPanel {...props} />);

HelpMenu.propTypes = {
  helpContext: PropTypes.string,
};

export default HelpMenu;
